import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** sets `label` on Mapping */
export const setMappingLabel =
  ({ key, label }: { key: string; label: string | null }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find((link) => link.key === key);
    if (!mapping || !isMapping(mapping)) {
      return;
    }

    setDataProperty<Mapping>(model)(mapping, 'label', label);
    doMappingUpdated(mapping)(model);
  };
